import { useAuth } from '@auth/AuthProvider';
import ServicesController from '@data/controller/ServicesController';
import usePagedList from '@hooks/usePagedList';
import { StaffAction } from '@interfaces/church.interfaces';
import { ChurchService } from '@interfaces/service.interface';

// Services for one campus and category, a page at a time, newest first.
// Nothing is fetched until a campus is chosen. A null category means the
// campus's uncategorized services.
export default function useServices(campusID: string | null, categoryID: string | null) {
  const auth = useAuth();
  const churchID = auth.churchId;
  // Staff who manage services also see ones that haven't happened yet.
  const includeUpcoming = auth.hasPermission(StaffAction.MANAGE_SERVICES);

  const key = churchID && campusID ? `${campusID}|${categoryID ?? ''}|${includeUpcoming}` : null;

  const list = usePagedList<ChurchService>(key, async (cursor) => {
    const response = await ServicesController.fetchServices(churchID!, campusID!, categoryID, includeUpcoming, cursor, auth);
    const body = response.body;

    if (response.error || !body) {
      return { error: response.error || 'Failed to load services.', status: response.status };
    }

    return { items: body.results ?? [], hasMore: body.hasMore === true, next: body.nextLastServiceID ?? null };
  });

  return { ...list, services: list.items } as const;
}
